import React from 'react';
import LandSearchListItem from './LandSearchListItem';

const LandSearchList = (props) => {
    return (
        <div className="land-search-list top-land-filter-search">
            <ul className="">
                {props.data.map((lot) =>
                    <LandSearchListItem data={lot} key={lot.id} />
                )}
            </ul>
        </div>
    );
};

export default LandSearchList;


/** WEBPACK FOOTER **
 ** ./src/modules/land-for-sale/elements/LandSearchList.js
 **/